import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

const CloseAssessmentDialog = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #E7E8E9",
          px: 3,
          py: 1.5,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: "18px",
          }}
        >
          Close Assessment
        </Typography>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Body */}
      <DialogContent>
        <Box
          sx={{
            textAlign: "center",
            py: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 500,
              color: "#374151",
              mb: 2,
            }}
          >
            Connection to the server has been lost.
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#DC2626",
              lineHeight: 1.6,
              mb: 2,
            }}
          >
            If you close this tab unsaved answers may be lost.
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#6B7280",
              fontWeight: 600,
              lineHeight: 1.6,
            }}
          >
            You can resume the exam again from the dashboard.
          </Typography>
        </Box>
      </DialogContent>

      {/* Footer */}
      <DialogActions
        sx={{
          borderTop: "1px solid #E7E8E9",
          justifyContent: "center",
          gap: 2,
          p: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            minWidth: 120,
            textTransform: "none",
            borderRadius: "8px",
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          sx={{
            minWidth: 180,
            textTransform: "none",
            borderRadius: "8px",
          }}
        >
          Close Assessment
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloseAssessmentDialog;